const getEnvVar = (varName: string): undefined | string => {
  return import.meta.env[varName];
};

if (import.meta.hot) {
  import.meta.hot.accept();
}

export default getEnvVar;
